import { actions } from './actions'

const initialState = {
  frutas: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function frutasReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FRUTAS_LOAD_REQUESTED:
      return { ...state, frutas: { ...state.frutas, loading: true } }
    case actions.FRUTAS_LOAD_SUCCEEDED:
      return {
        ...state,
        frutas: { ...state.frutas, data: action.payload, loading: false },
      }
    case actions.FRUTAS_LOAD_FILED:
      return {
        ...state,
        frutas: { ...state.frutas, loading: false, error: action.error },
      }
    case actions.FRUTA_UPDATE_REQUESTED:
      return {
        ...state,
        frutas: { ...state.frutas, loading: true, error: '' },
      }
    case actions.FRUTA_UPDATE_SUCCEEDED:
      return {
        ...state,
        frutas: {
          ...state.frutas,
          data: state.frutas.data.map(fruta =>
            fruta.id === action.payload.id ? action.payload : fruta,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FRUTA_UPDATE_FILED:
      return {
        ...state,
        frutas: { ...state.frutas, loading: false, error: action.error },
      }
    case actions.FRUTA_INSERT_REQUESTED:
      return {
        ...state,
        frutas: { ...state.frutas, loading: true, error: '' },
      }
    case actions.FRUTA_INSERT_SUCCEEDED:
      return {
        ...state,
        frutas: {
          ...state.frutas,
          data: [].concat(action.payload, state.frutas.data),
          loading: false,
          error: '',
        },
      }
    case actions.FRUTA_INSERT_FILED:
      return {
        ...state,
        frutas: { ...state.frutas, loading: false, error: action.error },
      }
    case actions.FRUTA_DELETE_REQUESTED:
      return {
        ...state,
        frutas: { ...state.frutas, loading: true, error: '' },
      }
    case actions.FRUTA_DELETE_SUCCEEDED:
      return {
        ...state,
        frutas: {
          ...state.frutas,
          data: state.frutas.data.filter(fruta => fruta.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.FRUTA_DELETE_FILED:
      return {
        ...state,
        frutas: { ...state.frutas, loading: false, error: action.error },
      }
    default:
      return state
  }
}
